// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"c826dd4c","453":"b34e65be","644":"8c298d78","732":"75405fe9"}[chunkId] + ".chunk.js";
};